import { AfterViewInit, Component } from '@angular/core';
import { LoaderService } from '../../services/loader.service';

@Component({
  standalone:false,
  selector: 'tde-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
// implements AfterViewInit
export class LoaderComponent {

  public loading: boolean = false;
  constructor(private loaderService: LoaderService) { }

  // ngAfterViewInit(): void {
  //   this.loaderService.isLoading.subscribe((v) => {
  //     Promise.resolve().then(() => {
  //       this.loading = v;
  //     }, 0);
  //   });
  // }
}
